import type { Observable } from 'rxjs';

import type { PageQuery, PagedResult } from '@domain/models/paged-result.model';
import type { CategorySort, Store, StoreCategory } from '@domain/models/store.model';

export abstract class StoreCategoryRepository {
  abstract list(query: PageQuery, isAdmin?: boolean): Observable<PagedResult<StoreCategory>>;

  abstract create(
    name: string,
    nameArabic: string,
    active: boolean,
    logoImage: string | null,
  ): Observable<void>;

  abstract update(
    id: number,
    name: string,
    nameArabic: string,
    active: boolean,
    logoImage: string | null,
    sort: CategorySort,
  ): Observable<void>;

  abstract updateSort(id: number, sort: CategorySort): Observable<void>;

  abstract listStores(categoryId: number): Observable<PagedResult<Store>>;
}
